// src/ui/Button.jsx
import React from "react";

export default function Button({
  children,
  onClick,
  variant = "solid",
  style = {},
}) {
  // Base styles
  const baseStyle = {
    borderRadius: "50px",
    padding: "14px 32px",
    fontWeight: "600",
    fontSize: "16px",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    display: "inline-flex", // ✅ ensures gap/margin works for icon+text
    alignItems: "center",
    justifyContent: "center",
  };

  // Variant styles
  const variantStyles =
    variant === "outline"
      ? {
          background: "transparent",
          color: "#E63946",
          border: "2px solid #E63946",
          boxShadow: "none",
        }
      : {
          background: "linear-gradient(135deg, #E63946, #FFC300)",
          border: "none",
          color: "white",
          boxShadow: "0 8px 20px rgba(230, 57, 70, 0.3)",
        };

  return (
    <button
      onClick={onClick}
      style={{
        ...baseStyle,
        ...variantStyles,
        ...style, // ✅ merges custom inline styles (like gap)
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        if (variant === "outline") {
          e.currentTarget.style.boxShadow =
            "0 4px 15px rgba(230, 57, 70, 0.2)";
        } else {
          e.currentTarget.style.boxShadow =
            "0 10px 25px rgba(230, 57, 70, 0.4)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        if (variant === "outline") {
          e.currentTarget.style.boxShadow = "none";
        } else {
          e.currentTarget.style.boxShadow =
            "0 8px 20px rgba(230, 57, 70, 0.3)";
        }
      }}
    >
      {children}
    </button>
  );
}
